import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { PanelInfoComponent } from './components/panel-info/panel-info.component';
import { FilterModule } from '../components/filter/filter.module';
import { FilterComponent } from '../components/filter/filter.component';


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    ModalModule,
    FontAwesomeModule,
    ProgressbarModule.forRoot(),
    FilterModule
  ],
  declarations: [
    PanelInfoComponent,
  ],
  exports: [
    FontAwesomeModule,
    ProgressbarModule,
    PanelInfoComponent,
    FilterComponent
  ]
})
export class SharedModule {

  static forRoot(): ModuleWithProviders {
    return {
        ngModule: SharedModule,
        providers: [ ]
    };
  }
}
